import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { UserService } from '@/core/services/open-api/user.service';
import { StdToasts, ToastService } from '@/core/services/toast.service';

@Component({
    selector: 'app-activation',
    templateUrl: './activation.component.html',
    // styleUrls: ['./activation.component.scss'],
    standalone: false,
})
export class ActivationComponent implements OnInit {
    public userActivated = false;
    public tokenExpired = false;
    public codeResent = false;
    private token = '';

    constructor(
        private toastService: ToastService,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const token = params.get('token');
            this.token = token!; // when the route is matched, the token is always present
            this.userService.activateUser(this.token).subscribe({
                next: () => {
                    this.userActivated = true;
                },
                error: (err) => {
                    switch (err.error.message) {
                        case 'Activation token expired':
                            this.tokenExpired = true;
                            break;
                        case 'Invalid activation Token':
                            void this.router.navigate(['/']);
                            break;
                        default:
                            console.error(err);
                            this.toastService.toast(StdToasts.STANDARD_ERROR);
                    }
                },
            });
        });
    }

    public resendCode(): void {
        this.userService.resendActivationCode(this.token).subscribe({
            next: () => {
                this.codeResent = true;
            },
            error: (err) => {
                console.error(err);
                this.toastService.toast(StdToasts.STANDARD_ERROR);
            },
        });
    }

    public goToLogin(): void {
        void this.router.navigate(['login']);
    }
}
